import React from 'react';
import ProductGrid from './ProductGrid';
import ProductListPage from 'rev.sdk.js/Templates/ProductList';
import * as AppActions from '../../AppActions';
import {getOutlet, useOutlet} from 'reconnect.js';

function ProductList(props) {
  const [dimension] = useOutlet('dimension');
  const mobile = dimension.rwd === 'mobile';

  const onCustomClick = async (item) => {
    if (props.location.pathname.indexOf('/products') === 0) {
      await AppActions.navigate(`/product/?id=${item.id}`, {loading: true});
    } else if (props.location.pathname.indexOf('/articles') === 0) {
      await AppActions.navigate(`/article/?id=${item.id}`, {loading: true});
    }
  };

  function renderCustomSection(props) {
    return null;
  }

  return (
    <div
      style={{
        maxWidth: 'var(--contentMaxWidth)',
        margin: '0 auto',
      }}>
      <ProductListPage
        {...props}
        ProductGrid={ProductGrid}
        onCustomClick={onCustomClick}
        renderCustomSection={renderCustomSection}
      />
    </div>
  );
}

export default ProductList;
